import 'semantic-ui-css/semantic.min.css';
import wrapWithProvider from "./wrap-with-provider";

export const wrapRootElement = wrapWithProvider;